///////////////
// Bar Chart //
///////////////

interface BarchartResult {
	name: string
	total: number
	color: string
}

export function extractBarChart(
	datas: {
		name: string
		data: number[]
	}[],
	colors: string[],
	dataPointIndex?: number
): BarchartResult[] {
	const results: BarchartResult[] = []

	for (let i = 0; i < datas.length; i++) {
		const data = datas[i]
		const color = colors[i]

		if (dataPointIndex !== undefined) {
			results.push({
				name: data.name,
				total: data.data[dataPointIndex],
				color,
			})
		} else {
			results.push({
				name: data.name,
				total: data.data.reduce((a, b) => a + b, 0),
				color,
			})
		}
	}

	return results
}

export function extractSingleBarChart(
	datas: {
		name: string
		data: number[]
	}[],
	colors: string[],
	dataPointIndex: number,
	seriesIndex: number
): BarchartResult {
	const result: BarchartResult = {
		name: '',
		total: 0,
		color: '',
	}

	const data = datas[seriesIndex]
	const color = colors[dataPointIndex]

	result.name = data.name
	result.total = data.data[dataPointIndex]
	result.color = color

	return result
}

////////////////
// Area Chart //
////////////////

interface AreaChartResult {
	name: string
	value: number
	color: string
}

export function extractAreaChart(
	datas: {
		name: string
		data: number[]
	}[],
	colors: string[],
	dataPointIndex: number,
	seriesIndex: number
): AreaChartResult {
	const result = {
		name: '',
		value: 0,
		color: '',
	}

	const data = datas[seriesIndex]
	const color = colors[dataPointIndex]

	result.name = data.name
	result.value = data.data[dataPointIndex]
	result.color = color

	return result
}
